import { showActionModal } from './blog-action-info-modal.js';

document.addEventListener('DOMContentLoaded', function () {

    const likeButton = document.querySelector(".like-dislike__button_like");
    const dislikeButton = document.querySelector(".like-dislike__button_dislike");
    const likeCounter = document.querySelector(".like-dislike__count_like");
    const dislikeCounter = document.querySelector(".like-dislike__count_dislike");
    const likesDislikesSection = document.querySelector(".like-dislike");

    if (!likeButton || !dislikeButton || !likeCounter || !dislikeCounter || !likesDislikesSection) {
        return;
    }

    const likesDislikesCounter = {
        likes: Number(likeCounter.dataset.likesCount),
        dislikes: Number(dislikeCounter.dataset.dislikesCount),
    };

    const articleId = Number(likesDislikesSection.dataset.articleId);
    const storageKey = 'user_all_reactions';

    let userAllReactions = JSON.parse(localStorage.getItem(storageKey)) || [];

    let isSending = false;

    let currentArticleReaction = userAllReactions.find(item => item.articleId === articleId);
    if (!currentArticleReaction) {
        currentArticleReaction = {
            articleId: articleId,
            state: 0,
        };
        userAllReactions.push(currentArticleReaction);
        localStorage.setItem(storageKey, JSON.stringify(userAllReactions));
    }
    let serverState = currentArticleReaction.state;

    function setState(state) {
        likeButton.classList.toggle("like-dislike__button_active", state === 1);
        dislikeButton.classList.toggle("like-dislike__button_active", state === -1);
    }

    function updateCounter(likeDelta = 0, dislikeDelta = 0) {
        likesDislikesCounter.likes = Math.max(0, likesDislikesCounter.likes + likeDelta);
        likesDislikesCounter.dislikes = Math.max(0, likesDislikesCounter.dislikes + dislikeDelta);
        likeCounter.innerHTML = likesDislikesCounter.likes.toString();
        dislikeCounter.innerHTML = likesDislikesCounter.dislikes.toString();
    }

    function saveCurrentReaction() {
        localStorage.setItem(storageKey, JSON.stringify(userAllReactions));
    }

    setState(currentArticleReaction.state);

    likeButton.addEventListener("click", function () {

        if (isSending) return;

        let action;
        let likeDelta = 0;
        let dislikeDelta = 0;

        switch (currentArticleReaction.state) {
            case 0:
                action = 'like';
                currentArticleReaction.state = 1;
                likeDelta = +1;
                break;

            case -1:
                action = 'switch_to_like';
                currentArticleReaction.state = 1;
                likeDelta = +1;
                dislikeDelta = -1;
                break;

            default:
                action = 'remove_like';
                currentArticleReaction.state = 0;
                likeDelta = -1;
        }

        updateCounter(likeDelta, dislikeDelta);
        setState(currentArticleReaction.state);

        sendReactionToServer({
            articleId,
            action,
            likeDelta,
            dislikeDelta
        });
    });

    dislikeButton.addEventListener("click", function () {

        if (isSending) return;

        let action;
        let likeDelta = 0;
        let dislikeDelta = 0;

        switch (currentArticleReaction.state) {
            case 0:
                action = 'dislike';
                currentArticleReaction.state = -1;
                dislikeDelta = +1;
                break;

            case 1:
                action = 'switch_to_dislike';
                currentArticleReaction.state = -1;
                likeDelta = -1;
                dislikeDelta = +1;
                break;

            default:
                action = 'remove_dislike';
                currentArticleReaction.state = 0;
                dislikeDelta = -1;
        }

        updateCounter(likeDelta, dislikeDelta);
        setState(currentArticleReaction.state);

        sendReactionToServer({
            articleId,
            action,
            likeDelta,
            dislikeDelta
        });
    });

    function sendReactionToServer({ articleId, action, likeDelta, dislikeDelta }) {

        if (currentArticleReaction.state !== serverState) {
            isSending = true;
            fetch('/articles/change-reaction', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || '',
                },
                body: JSON.stringify({ articleId, action })
            })
                .then(async (response) => {
                    if (!response.ok) {
                        if (response.status === 429) {
                            showActionModal('Слишком много запросов');
                            throw new Error('Too many requests');
                        }
                        showActionModal('Произошла ошибка');
                        throw new Error('Request failed');
                    }

                    const data = await response.json();
                    if (data.success) {
                        saveCurrentReaction();
                        serverState = currentArticleReaction.state;
                    } else {
                        currentArticleReaction.state = serverState;
                        updateCounter(-likeDelta, -dislikeDelta);
                        setState(serverState);
                    }
                })
                .catch(() => {
                    currentArticleReaction.state = serverState;
                    updateCounter(-likeDelta, -dislikeDelta);
                    setState(serverState);
                })
                .finally(() => {
                    isSending = false;
                    setState(serverState);
                });
        }
    }
});
